export const CAPTCHA_NOT_READY: string = `Captcha isn't ready`;
export const AUTH_WITH_PROVIDER_FAILED: string = `Something went wrong`;
